<template>
  <div class="view-wrapper is-initiative-detail">
    <ViewHeader :title="viewTitle" titleLabel="Initiative" :hideSectionHomeButton="true" :isFullViewport="true"
      :hideRoleTutorial="true">
      <template #icon>
        <span class="pi pi-home"></span>
      </template>
      <template #actions>
        <Button @click="handleDeleteInitiative($event)" class="p-button-text p-mr-auto" icon="pi pi-trash delete-icon"
          v-if="!isCreateTactic && canUserDeleteInitiative" />
        <Button @click="showCancelConfirmation($event)" class="p-mr-2 p-button-outlined"
          :label="saveButtonDisabled ? 'Close' : 'Cancel'" />
        <SplitButton id="btn_tactic_save" v-if="!isReadOnlyView" :class="saveButtonDisabled ? 'p-disabled' : null"
          :disabled="saveButtonDisabled" @click="handleSaveInitiative" label="Save" :model="saveMenuItems">
        </SplitButton>
      </template>
    </ViewHeader>
    <ViewMain :isFullViewport="true">
      <div class="initiative-detail-wrapper">
        <div v-if="isReadOnlyView && crossPlanForReadOnlyView" class="read-only-banner">
          <span v-if="crossPlanForReadOnlyView.isLead" class="pi pi-home"></span>
          <span>{{ crossPlanForReadOnlyView.isLead ? crossPlanForReadOnlyView.name : crossPlanForReadOnlyView.abbreviatedName }} &bull; Read-only</span>
        </div>
        <div class="details-container">
          <div class="p-d-flex">
            <div class="p-field p-mr-2">
              <label for="name">Name</label>
              <InputText id="name" v-model="localInitiative.title" placeholder="New Initiative"
                @input="nonConditionalChange" autocomplete="off" :disabled="!canUserEditFields"
                :class="nameInputStyleObject" />
            </div>
            <!-- <template v-if="!isInitiative">
              <div class="p-field p-mr-2">
                <label for="channel">Channel</label>
                <Dropdown
                  inputId="channel"
                  v-model="selectedChannel"
                  :options="channelOptions"
                  optionLabel="name"
                  optionDisabled="isDisabled"
                  placeholder="Select channel"
                  data-key="key"
                  @change="
                    () => {
                      onChannelInputChange()
                      nonConditionalChange()
                    }
                  "
                  :class="channelDropdownStyleObject"
                  :disabled="!canUserEditChannel"
                />
              </div>
            </template> -->
            <div class="p-field p-mr-2">
              <label for="type">Category</label>
              <Dropdown inputId="type" v-model="selectedType" :options="typeOptions" optionLabel="name"
                placeholder="Select Category" data-key="key" @change="
                  () => {
                    // onTypeInputChange()
                    nonConditionalChange()
                  }
                " :class="typeDropdownStyleObject" :disabled="!canUserEditFields ||
                  (selectedChannel && !selectedChannel.name) ||
                  (localInitiative.id?.intID !== 0)
                  " />
            </div>
            <!-- <template
              v-if="!isInitiative && selectedType.id && platformOptions.length"
            >
              <div class="p-field p-mr-2">
                <label for="platform">Platform</label>
                <MultiSelect
                  v-if="selectedType.shouldTacticsAllowMultiplePlatforms"
                  inputId="platform"
                  v-model="selectedPlatforms"
                  :options="platformOptions"
                  optionLabel="name"
                  placeholder="No Platform"
                  data-key="key"
                  :showClear="selectedPlatforms.length ? true : false"
                  @change="
                    () => {
                      onPlatformInputChange()
                      nonConditionalChange()
                    }
                  "
                  :disabled="!canUserEditFields"
                />
                <Dropdown
                  v-else
                  inputId="platform"
                  v-model="selectedPlatformSingle"
                  :options="platformOptions"
                  optionLabel="name"
                  placeholder="No Platform"
                  data-key="key"
                  :showClear="selectedPlatforms.length ? true : false"
                  @change="
                    () => {
                      onPlatformInputChange()
                      nonConditionalChange()
                    }
                  "
                  :disabled="!canUserEditFields"
                />
              </div>
            </template> -->
          </div>

          <!-- <div
            class="p-mb-4"
            v-if="
              !isInitiative &&
              !isMonthlyOnly &&
              selectedChannel.enableTacticFlagging
            "
          >
            <Checkbox
              id="isFlagged"
              v-model="localInitiative.isFlagged"
              :binary="true"
              class="p-mr-2"
              @change="
                () => {
                  onInputChange()
                  nonConditionalChange()
                }
              "
              :disabled="!canUserEditFields"
            />
            <label for="isFlagged">Flagged Tactic: Show On Flow View</label>
          </div> -->
        </div>

        <div class="time-frame-container">
          <div class="p-d-flex p-ai-center" v-show="isMonthlyOnly">
            <div v-if="isMonthlyOnly" class="p-field p-mr-2">
              <label for="start">Month</label>
              <Calendar id="start" v-model="localInitiative.startDate" view="month" dateFormat="mm/yy"
                :yearNavigator="true" :manualInput="false" :yearRange="$store.getters.datePickerYearRange"
                :showTime="false" appendTo="body" @hide="
                  () => {
                    onMonthlyFocusDateSelect()
                    onInputChange()
                    nonConditionalChange()
                  }
                " :disabled="!canUserEditFields" />
            </div>
          </div>
          <div class="p-d-flex p-ai-center" v-if="!isMonthlyOnly">
            <div class="p-field p-mr-2" v-if="!localInitiative.isUnscheduled">
              <label for="start">Start Date</label>
              <Calendar id="start" v-model="localInitiative.startDate" :manualInput="false" :monthNavigator="true"
                :yearNavigator="true" :yearRange="$store.getters.datePickerYearRange" :showTime="shouldShowTimeInput"
                hourFormat="12" dateFormat="m/d/yy" appendTo="body" @hide="
                  () => {
                    normalizeAllDayDates()
                    onInputChange()
                    nonConditionalChange()
                    // clearRepeat()
                  }
                " :disabled="!canUserEditFields">
                <template #footer v-if="shouldShowTimeInput">
                  <TimePicker :date="currentInitiative.startDate" :setDate="updateCurrentInitiativeStartDate" />
                </template>
              </Calendar>
            </div>
            <div v-if="shouldShowEndDateInput && !localInitiative.isUnscheduled" class="p-field p-mr-2">
              <label for="end">End Date</label>
              <Calendar id="end" v-model="localInitiative.endDate" :manualInput="false" :monthNavigator="true"
                :yearNavigator="true" :yearRange="$store.getters.datePickerYearRange" :showTime="shouldShowTimeInput"
                hourFormat="12" dateFormat="m/d/yy" appendTo="body" @hide="
                  () => {
                    normalizeAllDayDates()
                    onInputChange()
                    nonConditionalChange()
                  }
                " :disabled="!canUserEditFields">
                <template #footer v-if="shouldShowTimeInput">
                  <TimePicker :date="currentInitiative.endDate" :setDate="updateCurrentInitiativeEndDate" />
                </template>
              </Calendar>
            </div>
            <div class="p-ml-4 p-mr-4" v-if="!localInitiative.isUnscheduled">
              <Checkbox id="hasEndDate" class="p-mr-2" v-model="shouldShowEndDateInput" :binary="true" @change="
                () => {
                  onMultiDayChange()
                  nonConditionalChange()
                }
              " :disabled="!canUserEditFields" />
              <label for="hasEndDate">Show Duration</label>
            </div>
            <div class="p-ml-4 p-mr-4" v-if="!localInitiative.isUnscheduled">
              <Checkbox id="isAllDay" class="p-mr-2" v-model="localInitiative.isAllDay" :binary="true" @change="
                () => {
                  onAllDayChange()
                  nonConditionalChange()
                }
              " :disabled="!canUserEditFields" />
              <label for="isAllDay">All-Day</label>
            </div>
            <!-- <div v-if="!isInitiative">
              <Checkbox
                id="isUnscheduled"
                class="p-mr-2"
                v-model="localInitiative.isUnscheduled"
                :binary="true"
                @change="
                  () => {
                    onUnscheduledChange()
                    nonConditionalChange()
                  }
                "
                :disabled="!canUserEditFields"
              />
              <label for="isUnscheduled">Parking Lot</label>
              <span
                v-tooltip.bottom="
                  'Select &quot;Parking Lot&quot; when you want to enter unscheduled tactic ideas for the future. Once saved, they can be accessed via the Table view, Parking Lot. Turn off the &quot;Parking Lot&quot; designation when you are ready to schedule.'
                "
                class="pi pi-question-circle tooltip-color p-ml-2"
              ></span>
            </div> -->
          </div>
        </div>
        <!-- <div
          class="p-d-flex p-ai-center"
          v-if="!isInitiative && !localInitiative.isUnscheduled"
        >
          <div
            class="p-mr-4"
            v-if="
              (selectedType && !selectedType.name) ||
              (selectedType &&
                selectedType.name &&
                selectedType.name.toLowerCase() !==
                  $store.getters.monthlyFocusTypeName)
            "
          >
            <Checkbox
              id="tacticRepeats"
              class="p-mr-2"
              v-model="localInitiative.repeats"
              :binary="true"
              @change="
                () => {
                  onInputChange()
                  nonConditionalChange()
                }
              "
              :disabled="!canUserEditFields"
            />

            <label for="tacticRepeats">Repeats</label>
          </div>
          <div
            v-if="localInitiative.repeats && !localInitiative.isCustomRecurrence"
            class="p-field p-mr-2"
          >
            <label for="repeat-on">When:</label>
            <Dropdown
              id="repeat-on"
              :options="repeatOptions"
              :class="repeatOnInputStyleObject"
              v-model="localInitiative.rrule"
              optionLabel="label"
              optionValue="value"
              placeholder="Repeats on..."
              :showClear="localInitiative.rrule != ''"
              @change="
                (e) => {
                  onRepeatRuleInputChange(e)
                  onInputChange()
                  nonConditionalChange()
                }
              "
            />
          </div>
          <div
            v-if="localInitiative.repeats && localInitiative.isCustomRecurrence"
            class="p-mr-3"
            :class="{
              'p-invalid': invalidFields.includes('customRepeat'),
            }"
          >
            <strong>Custom:</strong>
            {{ customRecurrence.recurrenceText }}
            <a
              href=""
              class="p-ml-2 underline"
              @click="handleEditCustomRuleClick"
              >Edit</a
            >
            |
            <a
              href=""
              class="p-ml-2 underline"
              @click="handleRemoveCustomRuleClick"
              >Remove</a
            >
          </div>
          <div v-if="localInitiative.repeats" class="p-field p-mr-2">
            <label for="repeatStop">Stop repeating on:</label>
            <Calendar
              id="repeatStop"
              v-model="localInitiative.recurrenceEndDate"
              :manualInput="false"
              :monthNavigator="true"
              :yearNavigator="true"
              :yearRange="$store.getters.datePickerYearRange"
              :showTime="false"
              hourFormat="12"
              dateFormat="m/d/yy"
              placeholder="Never"
              @hide="
                () => {
                  onInputChange()
                  nonConditionalChange()
                }
              "
            />
          </div>
        </div> -->

        <div class="summary-container p-mt-6" v-if="currentPlan.isTacticSummaryFieldEnabled">
          <label for="summary">Notes</label>
          <QuillEditor 
            id="summary" 
            class="p-mt-2" 
            v-model="localInitiative.summary" @text-change="
              (event) => {
                nonConditionalChange()
                onEditorTextChange(event, 'notesMessage')
              }
            " 
            :disabled="!canUserEditFields" 
            :class="summaryInputStyleObject"
          ></QuillEditor>
          <div id="notesMessage"></div>
        </div>

        <!-- <div
          v-if="
            planLevelTacticFields &&
            planLevelTacticFields.length &&
            !isInitiative
          "
          class="
            custom-properties-container
            p-d-flex p-flex-wrap p-ai-start p-mt-4
          "
        >
          <template v-for="field of planLevelTacticFields">
            <div
              :key="field.key"
              class="p-field p-mr-2"
              :style="{
                'flex-basis': isFieldType(field, 'richtext') ? '100%' : 'auto',
              }"
            >
              <label :for="'custom_field_' + field.id.intID">{{
                field.name
              }}</label>
              <div v-if="isFieldType(field, 'image')">
                <div
                  v-if="getFieldValueForFieldId(field.id).value"
                  class="custom-field-image-controls"
                >
                  <div class="custom-field-image-controls-container">
                    <Button
                      label=""
                      class="p-button-lg p-button-outlined"
                      icon="pi pi-times-circle"
                      @click="removeCustomFieldImage(field.id)"
                    />
                    <Button
                      label=""
                      class="p-button-lg p-button-outlined"
                      icon="pi pi-search-plus"
                      @click="
                        () => {
                          showCustomFieldImageDialog = true
                          customFieldDialogImage = getCustomImageFieldUrl(
                            field.id
                          )
                        }
                      "
                    />
                  </div>
                  <img
                    class="custom-field-image"
                    :src="getCustomImageFieldUrl(field.id)"
                    alt=""
                  />
                </div>
                <FileUpload
                  :name="'customFieldImage' + field.id.intID"
                  :customUpload="true"
                  :maxFileSize="10000000"
                  :fileLimit="1"
                  mode="basic"
                  chooseLabel="Upload Image"
                  :auto="true"
                  accept="image/*"
                  @uploader="
                    (fileData) => uploadCustomFieldImage(field.id, fileData)
                  "
                  v-else
                >
                  <template #empty>
                    <p>Drag and drop an image here to upload.</p>
                  </template>
                </FileUpload>
              </div>
              <div v-else-if="isFieldType(field, 'richtext')">
                <QuillEditor
                  :id="'custom_field_' + field.id.intID"
                  v-model="getFieldValueForFieldId(field.id).value"
                  @text-change="(val) => {
                      conditionalChange(field, val)
                      onEditorTextChange(
                        val,
                        'custom_field_' + field.id.intID + '_message'
                      )
                    }"
                  :disabled="!canUserEditFields"
                  :class="customFieldRichTextField"
                ></QuillEditor>
                <div :id="'custom_field_' + field.id.intID + '_message'"></div>
              </div>
              <div v-else>
                <div
                  class="p-d-flex p-ai-center"
                  v-if="isFieldType(field, 'url')"
                >
                  <InputText
                    :inputId="'custom_field_' + field.id.intID"
                    v-model="getFieldValueForFieldId(field.id).value"
                    @input="(val) => conditionalChange(field, val)"
                    autocomplete="off"
                    :disabled="!canUserEditFields"
                    v-if="
                      editModeFieldIds.includes(field.id.intID) ||
                      getFieldValueForFieldId(field.id).value == ''
                    "
                  />
                  <a
                    class="edit-link"
                    v-else
                    :href="
                      editModeFieldIds.includes(field.id.intID) &&
                      getFieldValueForFieldId(field.id).value.indexOf('://') >
                        -1
                        ? getFieldValueForFieldId(field.id).value
                        : `${getFieldValueForFieldId(field.id).value}`
                    "
                    target="_blank"
                    >{{ getFieldValueForFieldId(field.id).value }}</a
                  >
                  <i
                    class="pi pi-check p-ml-2"
                    style="font-size: 1.5rem; font-weight: bold"
                    @click="updateEditModeFieldIds(field.id.intID)"
                    :disabled="!getFieldValueForFieldId(field.id).value"
                    v-if="
                      getFieldValueForFieldId(field.id).value == '' ||
                      editModeFieldIds.includes(field.id.intID)
                    "
                  />

                  <i
                    class="pi pi-pencil p-ml-2"
                    style="font-size: 1.5rem"
                    v-else
                    @click="updateEditModeFieldIds(field.id.intID)"
                  ></i>
                </div>
                <div class="p-d-flex p-ai-center" v-else>
                  <InputText
                    :inputId="'custom_field_' + field.id.intID"
                    v-model="getFieldValueForFieldId(field.id).value"
                    @input="(val) => conditionalChange(field, val)"
                    autocomplete="off"
                    :disabled="!canUserEditFields"
                  />
                </div>
              </div>
            </div>
          </template>
        </div> -->

        <!-- <div
          v-if="$store.getters.currentAccount.hasTacticTypeCF && typeLevelTacticFields && typeLevelTacticFields.length"
          class="
            custom-properties-container
            p-d-flex p-flex-wrap p-ai-start p-mt-4
          "
        >
          <template v-for="field of typeLevelTacticFields">
            <div
              :key="field.key"
              class="p-field p-mr-2"
              :style="{
                'flex-basis': isFieldType(field, 'richtext') ? '100%' : 'auto',
              }"
            >
              <label :for="'custom_field_' + field.id.intID">{{
                field.name
              }}</label>
              <div v-if="isFieldType(field, 'image')">
                <div
                  v-if="getFieldValueForFieldId(field.id).value"
                  class="custom-field-image-controls"
                >
                  <div class="custom-field-image-controls-container">
                    <Button
                      label=""
                      class="p-button-lg p-button-outlined"
                      icon="pi pi-times-circle"
                      @click="removeCustomFieldImage(field.id)"
                    />
                    <Button
                      label=""
                      class="p-button-lg p-button-outlined"
                      icon="pi pi-search-plus"
                      @click="
                        () => {
                          showCustomFieldImageDialog = true
                          customFieldDialogImage = getCustomImageFieldUrl(
                            field.id
                          )
                        }
                      "
                    />
                  </div>
                  <img
                    class="custom-field-image"
                    :src="getCustomImageFieldUrl(field.id)"
                    alt=""
                  />
                </div>
                <FileUpload
                  :name="'customFieldImage' + field.id.intID"
                  :customUpload="true"
                  :maxFileSize="10000000"
                  :fileLimit="1"
                  mode="basic"
                  chooseLabel="Upload Image"
                  :auto="true"
                  accept="image/*"
                  @uploader="
                    (fileData) => uploadCustomFieldImage(field.id, fileData)
                  "
                  v-else
                >
                  <template #empty>
                    <p>Drag and drop an image here to upload.</p>
                  </template>
                </FileUpload>
              </div>
              <div v-else-if="isFieldType(field, 'richtext')">
                <QuillEditor
                  :id="'custom_field_' + field.id.intID"
                  v-model="getFieldValueForFieldId(field.id).value"
                  @text-change="
                    (val) => {
                      conditionalChange(field, val)
                      onEditorTextChange(
                        val,
                        'custom_field_' + field.id.intID + '_message'
                      )
                    }
                  "
                  :disabled="!canUserEditFields"
                  :class="{'disable-editor': !canUserEditFields}"
                ></QuillEditor>
                <div :id="'custom_field_' + field.id.intID + '_message'"></div>
              </div>
              <div v-else>
                <div
                  class="p-d-flex p-ai-center"
                  v-if="isFieldType(field, 'url')"
                >
                  <InputText
                    :inputId="'custom_field_' + field.id.intID"
                    v-model="getFieldValueForFieldId(field.id).value"
                    @input="(val) => conditionalChange(field, val)"
                    autocomplete="off"
                    :disabled="!canUserEditFields"
                    v-if="
                      editModeFieldIds.includes(field.id.intID) ||
                      getFieldValueForFieldId(field.id).value == ''
                    "
                  />
                  <a
                    class="edit-link"
                    v-else
                    :href="
                      editModeFieldIds.includes(field.id.intID) &&
                      getFieldValueForFieldId(field.id).value.indexOf('://') >
                        -1
                        ? getFieldValueForFieldId(field.id).value
                        : `${getFieldValueForFieldId(field.id).value}`
                    "
                    target="_blank"
                    >{{ getFieldValueForFieldId(field.id).value }}</a
                  >
                  <i
                    class="pi pi-check p-ml-2"
                    style="font-size: 1.5rem; font-weight: bold"
                    @click="updateEditModeFieldIds(field.id.intID)"
                    :disabled="!getFieldValueForFieldId(field.id).value"
                    v-if="
                      getFieldValueForFieldId(field.id).value == '' ||
                      editModeFieldIds.includes(field.id.intID)
                    "
                  />

                  <i
                    class="pi pi-pencil p-ml-2"
                    style="font-size: 1.5rem"
                    v-else
                    @click="updateEditModeFieldIds(field.id.intID)"
                  ></i>
                </div>
                <div class="p-d-flex p-ai-center" v-else>
                  <InputText
                    :inputId="'custom_field_' + field.id.intID"
                    v-model="getFieldValueForFieldId(field.id).value"
                    @input="(val) => conditionalChange(field, val)"
                    autocomplete="off"
                    :disabled="!canUserEditFields"
                  />
                </div>
              </div>
            </div>
          </template>
        </div> -->
      </div>

      <div>
        <div class="plan-elements-container" v-if="$store.getters.currentTags.length">
          <hr class="p-my-4" />
          <div class="p-d-flex p-jc-between p-ai-start">
            <h2>Tags</h2>
            <Button label="Tags" icon="pi pi-plus-circle" @click="shouldShowTagList = true"
              :disabled="!canUserEditFields || !canUserEditTags" />
          </div>
          <div class="p-d-flex p-jc-start p-ai-start" style="width: 80%; min-width: 60rem">
            <template v-for="(
tagCategory, tagCategoryIndex
              ) in currentCategorizedTagsAssignedToInitiative">
              <div class="tag-list-column p-mr-6" :key="tagCategoryIndex" v-show="tagCategory.tags.length">
                <h3>{{ tagCategory.name }}</h3>
                <div class="p-d-flex p-flex-column p-ai-start">
                  <template v-for="tag of tagCategory.tags">
                    <div :key="tag.id.intID" class="p-d-flex p-ai-center p-mr-2 p-mb-2 tag-chip">
                      <div class="p-mr-2" :class="{
                        'is-nested': tag.isNested,
                        'is-lead': tag.isLead,
                      }">
                        <template v-if="isLeadPlan && tag.isNested">
                          {{ tag.abbreviatedPlanName }} | {{ tag.title }}
                        </template>
                        <template v-else>
                          {{ tag.title }}
                        </template>
                      </div>
                      <Button icon="pi pi-times-circle" class="p-button-text" @click="handleRemoveTag(tag.id)"
                        :disabled="!canUserEditTags" />
                    </div>
                  </template>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="initiative-detail-documents-container">
        <hr class="p-my-4" />
        <div class="p-d-flex p-jc-between p-ai-start">
          <h2>Documents</h2>
        </div>
        <DataTable :value="localInitiative.documents" :autoLayout="true" v-if="localInitiative.documents.length">
          <Column header="Name" key="id.intID">
            <template #body="slotProps">
              {{ slotProps.data.asset.name }}
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <div class="p-d-flex p-jc-end p-ai-center">
                <Button class="p-button-text p-button-icon-only">
                  <a target="_blank" :href="slotProps.data.asset.fileLocation" download style="color: #000">
                    <i class="pi pi-download"></i>
                  </a>
                </Button>
                <Button v-if="!isReadOnlyView" icon="pi pi-trash" class="p-button-text" @click="
                  (e) =>
                    deleteDocument(e, slotProps.data.id.intID, localInitiative)
                "></Button>
              </div>
            </template>
          </Column>
        </DataTable>

        <div v-if="!isReadOnlyView" class="upload-document-container p-d-flex">
          <label for="document-upload" class="p-button p-component p-button-text"
            style="border: 0.1rem solid #000; border-radius: 0">
            Select File
            <input id="document-upload" type="file" @change="(e) => onFileUpload(e, localInitiative)" hidden />
          </label>
          <InputText v-model="localInitiative.newFileName" />
          <Button label="Upload" icon="pi pi-upload" class="p-button-text"
            @click="uploadFile(localInitiative)"></Button>
        </div>
      </div>

      <div class="initiative-detail-supporting-tactics-container" v-if="nestedCustomizations.length">
        <hr class="p-my-4" />
        <div class="p-d-flex p-jc-start p-ai-start">
          <span class="pi pi-link p-mt-2" style="font-size: 1.2rem;"></span>
          <h2 class="p-ml-2">Nested Initiative Variants</h2>
        </div>
        <DataTable :value="nestedCustomizations" :autoLayout="true" v-if="nestedCustomizations.length" editMode="row"
          dataKey="id.intID" :editingRows.sync="customizationEditingRows" @row-edit-init="onCustomizationRowEditInit"
          @row-edit-save="onCustomizationRowEditSave">
          <Column field="fullPlanName" header="Nested Plan" sortable>
            <template #body="slotProps">
              {{ slotProps.data.fullPlanName }}
            </template>
          </Column>
          <Column field="startDate" header="Start Date" sortable>
            <template #body="slotProps">
              {{ slotProps.data.startDate.toLocaleDateString() }}
            </template>
            <template #editor>
              <Calendar v-model="currentEditingCustomization.startDate" :manualInput="false" :monthNavigator="true"
                :yearNavigator="true" :yearRange="$store.getters.datePickerYearRange" dateFormat="m/d/yy"
                appendTo="body" />
            </template>
          </Column>
          <Column field="endDate" header="End Date" sortable>
            <template #body="slotProps">
              {{ slotProps.data.endDate.toLocaleDateString() }}
            </template>
            <template #editor>
              <Calendar v-model="currentEditingCustomization.endDate" :manualInput="false" :monthNavigator="true"
                :yearNavigator="true" :yearRange="$store.getters.datePickerYearRange" dateFormat="m/d/yy"
                appendTo="body" />
            </template>
          </Column>
          <Column header="Notes" key="summary">
            <template #body="slotProps">
              <Button v-if="
                slotProps.data.summary !== null &&
                slotProps.data.summary !== ''
              " icon="pi pi-eye" class="p-button-icon-only p-button-rounded p-button-text" @mouseenter="
                (event) => {
                  currentOverlayHTML = slotProps.data.summary
                    ? slotProps.data.summary
                    : ''
                  $refs.richTextFieldOverlay?.show(event)
                }
              " @mouseleave="
                (event) => {
                  $refs.richTextFieldOverlay?.hide()
                }
              "></Button>
              <template v-else> None </template>
            </template>
          </Column>
          <Column v-if="canUserEditNestedCustomizations" :rowEditor="true" style="width: 10%; min-width: 8rem"
            bodyStyle="text-align: right;"></Column>
        </DataTable>
        <div v-else>
          <p>No nested variants found.</p>
        </div>
      </div>

      <div class="initiative-detail-supporting-tactics-container">
        <hr class="p-my-4" />
        <div class="p-d-flex p-jc-between p-ai-start">
          <h2>Supporting Tactics</h2>
        </div>
        <DataTable :value="supportingTactics" :autoLayout="true" v-if="supportingTactics.length">
          <Column field="title" header="Topic" sortable>
            <template #body="slotProps">
              <span :class="{ 'is-lead': slotProps.data.isLead }">
                {{ getTitleForTactic(slotProps.data) }}
              </span>
            </template>
          </Column>
          <Column field="channelName" header="Channel" sortable>
            <template #body="slotProps">
              {{ slotProps.data.channelName }}
            </template>
          </Column>
          <Column field="tacticTypeName" header="Tactic Type" sortable>
            <template #body="slotProps">
              {{ slotProps.data.tacticTypeName }}
            </template>
          </Column>
          <Column field="tacticPlatformIds" header="Platform">
            <template #body="slotProps">
              {{ getPlatformNamesForTactic(slotProps.data) }}
            </template>
          </Column>
          <Column field="startDate" header="Start Date" sortable>
            <template #body="slotProps">
              {{ slotProps.data.startDate.toLocaleDateString() }}
            </template>
          </Column>
          <Column field="endDate" header="End Date" sortable>
            <template #body="slotProps">
              {{ slotProps.data.endDate.toLocaleDateString() }}
            </template>
          </Column>
          <Column header="Notes" key="summary">
            <template #body="slotProps">
              <Button v-if="
                slotProps.data.summary !== null &&
                slotProps.data.summary !== ''
              " icon="pi pi-eye" class="p-button-icon-only p-button-rounded p-button-text" @mouseenter="
                (event) => {
                  currentOverlayHTML = slotProps.data.summary
                    ? slotProps.data.summary
                    : ''
                  $refs.richTextFieldOverlay?.show(event)
                }
              " @mouseleave="
                (event) => {
                  $refs.richTextFieldOverlay?.hide()
                }
              "></Button>
              <template v-else> None </template>
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <div class="p-d-flex p-jc-end">
                <Button label="Open" icon="pi pi-arrow-circle-up" class="p-button-text" @click="
                  () => {
                    $router.push({
                      path: `/account/${$store.getters.currentAccount.id.intID}/plan/${$route.params.planId}/tactic/${slotProps.data.id.intID}`,
                    })
                  }
                "></Button>
              </div>
            </template>
          </Column>
        </DataTable>
        <div v-else>
          <p>No supporting tactics found.</p>
        </div>
      </div>

      <Dialog header="Tags" :visible.sync="shouldShowTagList" :modal="true">
        <TagList :selectedTags="localInitiative.tags" :allowSelect="true" :allowEdit="false" :allowCreate="false"
          :allowList="true" @updateSelection="onTagListUpdate" />
      </Dialog>

      <OverlayPanel ref="richTextFieldOverlay" class="rich-text-field-overlay" appendTo="body">
        <div class="notes-field-content-container" v-html="currentOverlayHTML"></div>
      </OverlayPanel>
    </ViewMain>
  </div>
</template>

<script lang="ts">
import { format, isSameDay } from 'date-fns'
import Vue from 'vue'
import Checkbox from 'primevue/checkbox'
import Dropdown from 'primevue/dropdown'
import MultiSelect from 'primevue/multiselect'
import Dialog from 'primevue/dialog'
import RadioButton from 'primevue/radiobutton'
import ViewHeader from '@/components/ViewHeader.vue'
import ViewMain from '@/components/ViewMain.vue'
import TagList from '@/views/TagList.vue'
import Tactic from '@/models/Tactic'
import Plan from '@/models/Plan'
import Channel from '@/models/Channel'
import CustomRecurrence, {
  RecurrenceFrequency,
  RecurrenceByweekday,
} from '@/models/CustomRecurrence'
import TacticType from '@/models/TacticType'
import TacticField, { TacticFieldType } from '@/models/TacticField'
import TacticFieldValue from '@/models/TacticFieldValue'
import ID from '@/models/ID'
import Tag from '@/models/Tag'
import { AlertMessageSeverity } from '@/models/AlertMessage'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import SplitButton from 'primevue/splitbutton'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import TimePicker from '@/components/TimePicker.vue'
import { RRule, rrulestr } from 'rrule'
import FileUpload from 'primevue/fileupload'
import Role from '@/models/Role'
import TagCategory from '@/models/TagCategory'
import PlanDocument from '@/models/PlanDocument'
import RelatedInitiativeMapping from '@/models/RelatedInitiativeMapping'
import Tooltip from 'primevue/tooltip'
import QuillEditor from '@/components/QuillEditor.vue'
import Initiative from '@/models/Initiative'
import InitiativeChannel from '@/models/InitiativeChannel'
import InitiativeType from '@/models/InitiativeType'
import InitiativeCustomization from '@/models/InitiativeCustomization'

Vue.component('Checkbox', Checkbox)
Vue.component('Dropdown', Dropdown)
Vue.component('MultiSelect', MultiSelect)
Vue.component('Dialog', Dialog)
Vue.component('InputNumber', InputNumber)
Vue.component('Button', Button)
Vue.component('SplitButton', SplitButton)
Vue.component('FileUpload', FileUpload)
Vue.component('TimePicker', TimePicker)
Vue.component('RadioButton', RadioButton)
Vue.component('DataTable', DataTable)
Vue.component('Column', Column)

export default Vue.extend({
  name: 'InitiativeDetail',

  components: {
    ViewHeader,
    ViewMain,
    TagList,
    QuillEditor,
  },
  directives: {
    tooltip: Tooltip,
  },
  data: () => {
    return {
      // TODO: remove non-initiative data properties
      // selectedChannel: {} as InitiativeChannel,
      selectedType: {} as InitiativeType,
      // selectedPlatforms: [] as TacticPlatform[],
      nonReactive: {} as any,
      shouldShowTagList: false as boolean,
      currentSelectInitiativeTypeName: '' as string,
      currentSelectInitiativeId: {} as ID,
      currentSelectInitiativeTitle: '' as string,
      shouldShowTimeInput: true as boolean,
      shouldShowEndDateInput: false as boolean,
      tagUpdateItterator: 0 as number,
      initialStartDate: '' as string,
      initialEndDate: '' as string,
      initialTacticName: '' as string,
      initialChannel: '' as string,
      // initialEstimatedCost: 0 as number,
      // initialActualCost: 0 as number,
      initialType: '' as string,
      // initialPlatform: '' as string,
      // initialRelatedInitiatives: '' as string,
      // initialFieldValues: {} as {},
      // updatedFieldValues: {} as {},
      initialTags: {} as {},
      initialSummary: '' as string,
      saveButtonDisabled: true as boolean,
      invalidFields: [] as string[],
      // customRecurrence: {
      //   freq: RecurrenceFrequency['WEEKLY'],
      //   interval: 1,
      //   byweekday: RecurrenceByweekday['MO'],
      //   monthlyRule: '',
      //   recurrenceText: '',
      // } as CustomRecurrence,
      // customRecurrenceFields: {
      //   byweekday: [
      //     {
      //       value: RecurrenceByweekday['SU'],
      //       label: 'Sunday',
      //     },
      //     {
      //       value: RecurrenceByweekday['MO'],
      //       label: 'Monday',
      //     },
      //     {
      //       value: RecurrenceByweekday['TU'],
      //       label: 'Tuesday',
      //     },
      //     {
      //       value: RecurrenceByweekday['WE'],
      //       label: 'Wednesday',
      //     },
      //     {
      //       value: RecurrenceByweekday['TH'],
      //       label: 'Thursday',
      //     },
      //     {
      //       value: RecurrenceByweekday['FR'],
      //       label: 'Friday',
      //     },
      //     {
      //       value: RecurrenceByweekday['SA'],
      //       label: 'Saturday',
      //     },
      //   ],
      //   freq: [
      //     {
      //       value: RecurrenceFrequency['DAILY'],
      //       label: 'Days',
      //     },
      //     {
      //       value: RecurrenceFrequency['WEEKLY'],
      //       label: 'Weeks',
      //     },
      //     {
      //       value: RecurrenceFrequency['MONTHLY'],
      //       label: 'Months',
      //     },
      //     {
      //       value: RecurrenceFrequency['YEARLY'],
      //       label: 'Years',
      //     },
      //   ],
      // },
      // showCustomRecurrenceDialog: false as boolean,
      // isCustomRecurrence: false as boolean,
      // showCustomFieldImageDialog: false as boolean,
      // customFieldDialogImage: '' as string,
      localInitiative: {} as Initiative,
      editModeFieldIds: [] as number[],
      customizationEditingRows: [] as InitiativeCustomization[],
      currentEditingCustomization: {
        startDate: new Date(),
        endDate: new Date(),
      } as { startDate: Date; endDate: Date },
      // customImageFieldUrlsMap: [] as {
      //   fieldId: number | string
      //   valueId: number | string
      //   url: string
      // }[],
      currentOverlayHTML: '' as string,
    }
  },
  computed: {
    currentStartDate: {
      get: function (): Date {
        return this.localInitiative.startDate
      },
      set: function (newValue: Date) {
        this.localInitiative.startDate = newValue
      },
    },
    // selectedPlatformSingle: {
    //   get(): TacticPlatform | null {
    //     return this.selectedPlatforms.length ? this.selectedPlatforms[0] : null
    //   },
    //   set(newValue: TacticPlatform) {
    //     this.selectedPlatforms = [newValue]
    //   },
    // },
    nestedCustomizations(): InitiativeCustomization[] {
      if (this.localInitiative.id.intID === 0) {
        return []
      }
      return this.localInitiative.initiativeCustomizations
    },
    supportingTactics(): Tactic[] {
      if (this.localInitiative.id.intID === 0) {
        return []
      }
      // Include all tactics related to lead initiative and nested customizations (RelatedInitiativeMappings for InitiativeCustomizations have the initiativeId of their associated lead initiative)
      return this.$store.getters.currentPlan.tactics.filter((tactic) =>
        tactic.relatedInitiatives.map((mapping: RelatedInitiativeMapping) => mapping.initiativeId.intID).includes(this.localInitiative.id.intID)
      )
    },
    saveMenuItems(): {}[] {
      return [
        {
          label: 'Save and Copy',
          command: (event) => {
            this.handleSaveInitiative(true).then((returnedInitiative) => {
              this.$store.commit('setCurrentInitiativeIntID', 0)
              this.$router.push({
                path: `/account/${this.$store.getters.currentAccount.id.intID
                  }/plan/${this.$route.params.planId}/${this.isInitiative ? 'initiative' : 'tactic'
                  }/0?new=${Date.now()}&copyof=${returnedInitiative.id.intID}`,
              })
            })
          },
        },
        {
          label: 'Save and Add New',
          command: (event) => {
            this.handleSaveInitiative(true).then((returnedInitiative) => {
              this.$store.commit('setCurrentInitiativeIntID', 0)
              let queryString = `new=${Date.now()}`
              if (this.$route.query && this.$route.query.datetime) {
                queryString = `${queryString}&datetime=${this.$route.query.datetime}`
              }
              this.$router.push({
                path: `/account/${this.$store.getters.currentAccount.id.intID
                  }/plan/${this.$route.params.planId}/${this.isInitiative ? 'initiative' : 'tactic'
                  }/0?${queryString}`,
              })
            })
          },
        },
      ]
    },
    viewTitle(): string {
      const tacticType = 'Initiative'
      const tacticTitle = this.localInitiative ? this.localInitiative.title : ''
      return this.isCreateTactic ? 'New ' + tacticType : tacticTitle
    },
    isCreateInitiative(): boolean {
      return this.$store.getters.currentInitiativeIntID == 0 ? true : false
    },
    // TODO: remove isInitiative if possible
    isInitiative(): boolean {
      return true
    },
    currentPlan(): Plan {
      return this.$store.getters.currentPlan
    },
    isLeadPlan(): boolean {
      return this.$store.getters.currentPlan.plans.length ? true : false
    },
    currentInitiative(): Initiative {
      return this.localInitiative
    },
    // An initiative opened from the other plan in a lead/nested pair (e.g. a nested plan's
    // initiative viewed from its lead plan, or vice versa) is always view-only, regardless
    // of the viewer's role. Mirrors TacticDetail's isReadOnlyView — `isLead` reflects the
    // owning plan's own type, so this compares against the current plan's own type.
    isReadOnlyView(): boolean {
      if (this.isCreateTactic) {
        return false
      }
      return !(
        (this.isLeadPlan && this.currentInitiative.isLead) ||
        (!this.isLeadPlan && !this.currentInitiative.isLead)
      )
    },
    crossPlanForReadOnlyView(): Plan | null {
      if (!this.isReadOnlyView) {
        return null
      }
      return (
        this.$store.getters.allPlans.find(
          (plan: Plan) => plan.id.intID === this.currentInitiative.planId.intID
        ) || null
      )
    },
    currentCategorizedTagsAssignedToInitiative(): TagCategory[] {
      this.tagUpdateItterator
      const localTagList = [...this.localInitiative.tags]

      // Create categories
      const categories: TagCategory[] = []
      localTagList.forEach((tag) => {
        const categoryIndex = categories.findIndex(
          (cat) => cat.name === tag.type
        )
        if (categoryIndex === -1) {
          categories.push(new TagCategory(categories.length + 1, tag.type))
        }
      })
      // Add tags to categories
      localTagList.forEach((tag) => {
        const categoryIndex = categories.findIndex(
          (cat) => cat.name === tag.type
        )
        categories[categoryIndex === -1 ? 3 : categoryIndex].tags.push(tag)
      })
      // Sort categories alphabetically
      categories.sort((a, b) => {
        if (a.name === b.name) {
          return 0
        }
        return a.name > b.name ? 1 : -1
      })
      // Sort tags within categories according to orderIndex
      categories.forEach((tagCat) => {
        tagCat.tags.sort((a, b) => {
          if (a.orderIndex === b.orderIndex) {
            return 0
          }
          return a.orderIndex > b.orderIndex ? 1 : -1
        })
      })
      return categories
    },
    // channelOptions(): Channel[] {
    //   return this.$store.getters.currentChannels
    //     .filter((channel) => {
    //       return (this.isLeadPlan && channel.isLead) || !this.isLeadPlan
    //     })
    //     .sort((a, b) => {
    //       // Sort lead before nested
    //       if (a.isLead && !b.isLead) {
    //         return -1
    //       }
    //       if (!a.isLead && b.isLead) {
    //         return 1
    //       }
    //       return 0
    //     })
    //     .sort((a, b) => {
    //       // Sort by user-defined orderIndex
    //       if (a.orderIndex === b.orderIndex) {
    //         return 0
    //       }
    //       return a.orderIndex > b.orderIndex ? 1 : -1
    //     })
    //     .map((channel) => {
    //       // Disable channel options that the user doesn't have rights for
    //       if (
    //         this.$store.getters.currentUserRole.canEditAllChannels === false
    //       ) {
    //         const matchingEnabledChannels =
    //           this.$store.getters.currentUserRole.channels.filter(
    //             (channelId) => channelId.intID === channel.id.intID
    //           )
    //         if (matchingEnabledChannels.length === 0) {
    //           channel.isDisabled = true
    //         }
    //       }
    //       return channel
    //     })
    // },
    selectedChannel(): InitiativeChannel {
      return this.$store.getters.currentPlan.initiativeChannel
    },
    typeOptions(): InitiativeType[] {
      // let returnArray = [] as InitiativeType[]
      // if (!this.selectedChannel.id) {
      //   return returnArray
      // }
      // if (!this.selectedChannel.useMonthlyFocusType) {
      //   returnArray = this.selectedChannel.tacticTypes.filter(
      //     (type) =>
      //       type.name.toLowerCase() !== this.$store.getters.monthlyFocusTypeName
      //   )
      // } else {
      // returnArray = this.selectedChannel.initiativeTypes
      // }

      const returnArray = this.selectedChannel.sortedInitiativeTypes
      return returnArray.sort((a, b) => a.orderIndex - b.orderIndex)
    },

    // combinedTacticFields(): TacticField[] {
    //   if (this.selectedType && this.selectedType?.tacticFields?.length) {
    //     return this.currentPlan.tacticFields.concat(
    //       this.selectedType?.tacticFields
    //     )
    //   }
    //   return this.currentPlan.tacticFields
    // },
    // planLevelTacticFields(): TacticField[] {
    //   return this.currentPlan.tacticFields
    // },
    // typeLevelTacticFields(): TacticField[] {
    //   if (this.selectedType) {
    //     return this.selectedType.tacticFields
    //   }
    //   return []
    // },

    // filteredInitiativesInCategories(): TacticType[] {
    //   const returnArray = [] as TacticType[]
    //   this.$store.getters.allInitiativesInCategories.forEach((type) => {
    //     const thisType = {...type}
    //     thisType.tactics = type.tactics.filter(
    //       (initiative) =>
    //         (!this.isLeadPlan || (this.isLeadPlan && !initiative.isNested)) &&
    //         this.isInitiativeTouchingTactic(initiative)
    //     )
    //     returnArray.push(thisType)
    //   })
    //   return returnArray.sort((a, b) => a.orderIndex - b.orderIndex)
    // },
    // customRecurrenceMonthlyOptions(): object[] {
    //   const startDate = new Date(this.localInitiative.startDate)
    //   const dtStart = this.getRecurranceFormattedStringForDate(startDate)

    //   return [
    //     {
    //       value: `BYMONTHDAY=${format(startDate, 'd')}`,
    //       label: `The ${format(startDate, 'do')}`,
    //     },
    //     {
    //       ...this.getMonthlyByDay(startDate, dtStart, true),
    //     },
    //   ]
    // },
    // repeatOptions(): object[] {
    //   const startDate = new Date(this.localInitiative.startDate)
    //   const dtStart = this.getRecurranceFormattedStringForDate(startDate)
    //   const recurrenceEndDate = this.localInitiative.recurrenceEndDate ? new Date(this.localInitiative.recurrenceEndDate) : null
    //   const untilDate = recurrenceEndDate ? this.getRecurranceFormattedStringForDate(recurrenceEndDate, false) : null

    //   const returnArray = [
    //     {
    //       value: `${dtStart}FREQ=DAILY${untilDate ? ';'+untilDate : ''}`,
    //       label: 'Daily',
    //     },
    //     {
    //       value: `${dtStart}FREQ=WEEKLY;WKST=SU;BYDAY=${format(
    //         startDate,
    //         'EEEEEE'
    //       ).toUpperCase()}${untilDate ? ';'+untilDate : ''}`,
    //       label: `Weekly on ${format(startDate, 'EEEE')}`,
    //     },
    //     {
    //       value: `${dtStart}FREQ=MONTHLY;BYMONTHDAY=${format(
    //         startDate,
    //         'd'
    //       )}${untilDate ? ';'+untilDate : ''}`,
    //       label: `Monthly on the ${format(startDate, 'do')}`,
    //     },
    //     {
    //       ...this.getMonthlyByDay(startDate, dtStart),
    //     },
    //     {
    //       value: `${dtStart}FREQ=YEARLY${untilDate ? ';'+untilDate : ''}`,
    //       label: `Annually on ${format(startDate, 'MMM')} ${format(
    //         startDate,
    //         'd'
    //       )}`,
    //     },
    //     {
    //       value: 'custom',
    //       label: 'Custom',
    //     },
    //   ]
    //   return returnArray
    // },
    // isCustomRecurrenceValid(): boolean {
    //   const {freq, monthlyRule, byweekday} = this.customRecurrence

    //   return (
    //     freq === RecurrenceFrequency['DAILY'] ||
    //     freq === RecurrenceFrequency['YEARLY'] ||
    //     (freq === RecurrenceFrequency['MONTHLY'] && !!monthlyRule) ||
    //     (freq === RecurrenceFrequency['WEEKLY'] && !!byweekday)
    //   )
    // },
    isMonthlyOnly(): boolean {
      if (this.selectedType.name) {
        return (
          this.selectedType.name.toLowerCase() ==
          this.$store.getters.monthlyFocusTypeName ||
          this.selectedType.name.toLowerCase() ==
          InitiativeType.INITIATIVE_TYPE_NAME_MONTHLY_THEME
        )
      }
      return false
    },

    canUserEditChannel(): boolean {
      return true
    },
    canUserDeleteInitiative(): boolean {
      return !this.isReadOnlyView && this.$store.getters.currentPlanPermissionLevel <= Role.LEVEL_CONTRIBUTOR
    },
    canUserEditFields(): boolean {
      return (
        !this.isReadOnlyView &&
        this.canUserEditChannel &&
        this.$store.getters.currentPlanPermissionLevel <= Role.LEVEL_CONTRIBUTOR
      )
    },
    canUserEditTags(): boolean {
      return !this.isReadOnlyView && this.$store.getters.currentPlanPermissionLevel <= Role.LEVEL_CONTRIBUTOR
    },
    canUserEditNestedCustomizations(): boolean {
      return !this.isReadOnlyView && this.$store.getters.currentPlanPermissionLevel <= Role.LEVEL_CONTRIBUTOR
    },

    nameInputStyleObject(): {} {
      return { 'p-invalid': this.invalidFields.includes('title') }
    },
    // channelDropdownStyleObject(): {} {
    //   return {'p-invalid': this.invalidFields.includes('channel')}
    // },
    typeDropdownStyleObject(): {} {
      return { 'p-invalid': this.invalidFields.includes('type') }
    },
    // repeatOnInputStyleObject(): {} {
    //   return {'p-invalid': this.invalidFields.includes('rrule')}
    // },
    summaryInputStyleObject(): {} {
      return { 'disable-editor': !this.canUserEditFields }
    },
    // customFieldRichTextField(): {} {
    //   return {'disable-editor': !this.canUserEditFields}
    // },
    isCreateTactic(): boolean {
      return Number(this.$route.params.initiativeId) === 0
    },
  },
  watch: {
    selectedType() {
      if (this.isMonthlyOnly) {
        this.onMonthlyFocusDateSelect()
      }
    },
    // localInitiative: function () {
    //   if (this.localInitiative.rrule && this.localInitiative.isCustomRecurrence) {
    //     const rule = rrulestr(this.localInitiative.rrule)
    //     this.customRecurrence = {
    //       ...this.customRecurrence,
    //       recurrenceText: rule.toText(),
    //     }
    //   }
    // },
  },
  created: function () {
    //Display loading blocker until API calls return values
    this.$store.commit('updateIsUIBlocked', true)

    // this.nonReactive.localFieldValues = [] as TacticFieldValue[]
    this.$store.commit('setCurrentInitiativeIntID', Number(this.$route.params.initiativeId))
    this.localInitiative = this.$store.getters.currentInitiative
    this.setInitialConditionalValues()

    //Is this a new or existing initiative
    if (!this.isCreateTactic) {
      // Fetch summary
      const summaryContentUrl = this.localInitiative.initiativeSummary?.contentUrl
      if (summaryContentUrl) {
        this.$store.getters.services.initiatives
          .fetchSummaryContent(summaryContentUrl)
          .then((html: string) => {
            this.localInitiative.summary = html
            this.initialSummary = JSON.stringify(html)
          })
          .finally(() => {
            // this.createPlaceholderRelatedInitiatives()
            this.updateSelectedChannelTypePlatform()
            this.updateEndDateInputVisibility()
            this.setInitialValues()
            this.nonConditionalChange()
            // this.updateCustomRecurrenceValues()
            // this.updateLocalFieldValues()
            this.$store.commit('updateIsUIBlocked', false)
          })
      }else{
        // this.createPlaceholderRelatedInitiatives()
        this.updateSelectedChannelTypePlatform()
        this.updateEndDateInputVisibility()
        this.setInitialValues()
        this.nonConditionalChange()
        // this.updateCustomRecurrenceValues()
        // this.updateLocalFieldValues()
        this.$store.commit('updateIsUIBlocked', false)
      }

      // this.$store
      //   .dispatch('refreshCurrentTactic')
      //   .then(
      //     (returnedTactic: Tactic) => {
      //       // this.localInitiative = this.updateTacticWithStashedLocalPropertyValues(
      //       //   this.localInitiative,
      //       //   returnedTactic
      //       // )
      //       this.createPlaceholderRelatedInitiatives()
      //       this.updateSelectedChannelTypePlatform()
      //       this.updateEndDateInputVisibility()
      //       this.setInitialValues()
      //       this.nonConditionalChange()
      //       this.updateCustomRecurrenceValues()
      //       this.updateLocalFieldValues()
      //     },
      //     (error) => {
      //       Vue.prototype.$toast.add({
      //         severity: AlertMessageSeverity.error,
      //         summary: 'Error refreshing tactic.',
      //         detail: error,
      //         life: 3000,
      //       })
      //     }
      //   )
      //   .finally(() => {
      //     this.$store.commit('updateIsUIBlocked', false)
      //   })
    } else {
      // Determine date for new tactic
      let newStartDate: Date
      const dateQueryParamString = this.$route.query?.datetime as string
      if (this.$route.query?.datetime) {
        newStartDate = new Date(dateQueryParamString)
        if (this.$route.query?.datetime.indexOf('T') < 0) {
          newStartDate.setHours(8, 0, 0, 0)
          newStartDate.setMinutes(0)
        }
      } else {
        newStartDate = new Date()
        newStartDate.setHours(8, 0, 0, 0)
      }

      //Ensure new tactic properties are reset if creating new tactic after cancelling previously
      this.localInitiative.title = ''
      this.localInitiative.startDate = newStartDate
      this.localInitiative.endDate = new Date(newStartDate)
      this.$store.commit('updateIsUIBlocked', false)
      this.updateSelectedChannelTypePlatform()

      // Default initiatives to all day and show end date input
      this.localInitiative.isAllDay = true
      this.shouldShowEndDateInput = true
      this.shouldShowTimeInput = false
      this.localInitiative.startDate.setHours(8, 0, 0, 0)
      this.localInitiative.endDate.setHours(8, 0, 0, 0)

      if (this.$route.query.copyof && this.$route.params.initiativeId == '0') {
        this.copyInitiative()
        this.enableSaveButton()
      }
    }
  },
  mounted() {
    // Fetch tactics related to initiative to populate related tactics table
    this.$store.dispatch('fetchTacticsRelatedToInitiative', this.$route.params.initiativeId)
  },
  beforeRouteLeave: function (to, from, next) {
    this.$destroy()
    next()
  },
  beforeDestroy: function () {
    this.localInitiative = new Initiative()
    // this.selectedChannel = new InitiativeChannel()
    this.selectedType = new InitiativeType()
    this.currentSelectInitiativeId = new ID()
    this.nonReactive = {}
  },
  methods: {
    disableSaveButton() {
      this.saveButtonDisabled = true
    },
    enableSaveButton() {
      if (
        !this.localInitiative.title ||
        this.localInitiative.title === '' ||
        !this.selectedType ||
        !this.selectedType.id ||
        this.selectedType.id.intID === 0
      ) {
        return
      }
      this.saveButtonDisabled = false
    },
    getRecurranceFormattedStringForDate(inputDate: Date, isStartDate: boolean = true): string {
      const year = inputDate.getFullYear()
      const month =
        inputDate.getMonth() > 8
          ? inputDate.getMonth() + 1
          : '0' + (inputDate.getMonth() + 1)
      const date =
        inputDate.getDate() > 9
          ? inputDate.getDate()
          : '0' + inputDate.getDate()
      const hours =
        inputDate.getHours() > 9
          ? inputDate.getHours()
          : '0' + inputDate.getHours()
      const minutes =
        inputDate.getMinutes() > 9
          ? inputDate.getMinutes()
          : '0' + inputDate.getMinutes()
      const seconds =
        inputDate.getSeconds() > 9
          ? inputDate.getSeconds()
          : '0' + inputDate.getSeconds()

      if (isStartDate) {
        return `DTSTART=${year}${month}${date}T${hours}${minutes}${seconds};`
      }
      return `UNTIL=${year}${month}${date}T${hours}${minutes}${seconds}Z`
    },
    getTitleForTactic(tactic: Tactic) {
      let returnString = tactic.title
      if (this.isLeadPlan && tactic.abbreviatedPlanName !== '') {
        if (returnString.length > 0) {
          returnString = tactic.abbreviatedPlanName + '  |  ' + returnString
        } else {
          returnString = tactic.abbreviatedPlanName
        }
      }
      return returnString
    },
    onCustomizationRowEditInit(event) {
      this.currentEditingCustomization.startDate = new Date(event.data.startDate)
      this.currentEditingCustomization.endDate = new Date(event.data.endDate)
    },
    onCustomizationRowEditSave(event) {
      const thisCustomization = event.data as InitiativeCustomization
      const newStartDate = new Date(this.currentEditingCustomization.startDate)
      let newEndDate = new Date(this.currentEditingCustomization.endDate)

      // Auto-correct invalid date range
      if (newEndDate < newStartDate) {
        newEndDate = new Date(newStartDate)
      }
      newStartDate.setHours(8, 0, 0, 0)
      newEndDate.setHours(8, 0, 0, 0)

      if (
        newStartDate.getTime() === thisCustomization.startDate.getTime() &&
        newEndDate.getTime() === thisCustomization.endDate.getTime()
      ) {
        return
      }

      const initialStartDate = thisCustomization.startDate
      const initialEndDate = thisCustomization.endDate
      thisCustomization.startDate = newStartDate
      thisCustomization.endDate = newEndDate

      this.$store.getters.services.initiatives
        .updateCustomization(thisCustomization)
        .then(
          (returnedCustomization: InitiativeCustomization) => {
            thisCustomization.startDate = returnedCustomization.startDate
            thisCustomization.endDate = returnedCustomization.endDate
            this.$store.dispatch(
              'updateInitiativeCustomizationInCurrentPlan',
              returnedCustomization
            )

            Vue.prototype.$toast.add({
              severity: AlertMessageSeverity.success,
              summary: 'Nested variant updated.',
              life: 3000,
            })
          },
          () => {
            thisCustomization.startDate = initialStartDate
            thisCustomization.endDate = initialEndDate

            Vue.prototype.$toast.add({
              severity: AlertMessageSeverity.error,
              summary: 'Error updating nested variant.',
            })
          }
        )
    },
    getPlatformNamesForTactic(tactic: Tactic): string {
      return this.$store.getters.platformNamesForIds(tactic.tacticPlatformIds)
    },
    // getInitiativeMappingForType(type: TacticType): RelatedInitiativeMapping {
    //   const thisMappingObj = this.localInitiative.relatedInitiatives.find(
    //     (mappingObj: RelatedInitiativeMapping) =>
    //       mappingObj.tacticTypeId.intID === type.id.intID
    //   )
    //   return thisMappingObj ? thisMappingObj : new RelatedInitiativeMapping()
    // },
    // isInitiativeTouchingTactic(initiative: Tactic): boolean {
    //   const extendedStartDate = new Date(initiative.startDate)
    //   extendedStartDate.setDate(extendedStartDate.getDate() - 60)
    //   extendedStartDate.setHours(0, 0, 0, 0)
    //   const extendedEndDate = new Date(initiative.endDate)
    //   extendedEndDate.setDate(extendedEndDate.getDate() + 60)
    //   extendedEndDate.setHours(23, 59, 59, 999)
    //   return (
    //     (this.localInitiative.startDate >= extendedStartDate &&
    //       this.localInitiative.startDate <= extendedEndDate) ||
    //     (this.localInitiative.endDate >= extendedStartDate &&
    //       this.localInitiative.endDate <= extendedEndDate)
    //   )
    // },
    // createPlaceholderRelatedInitiatives() {
    //   // Create mapping object for each type of initiative
    //   this.filteredInitiativesInCategories.forEach((tacticType) => {
    //     if (
    //       !this.localInitiative.relatedInitiatives.find(
    //         (mappingObj) =>
    //           mappingObj.tacticTypeId.intID === tacticType.id.intID
    //       )
    //     ) {
    //       this.createSinglePlaceholderRelatedInitiative(tacticType)
    //     }
    //   })
    // },
    // createSinglePlaceholderRelatedInitiative(
    //   tacticType
    // ): RelatedInitiativeMapping {
    //   const newMappingForType = new RelatedInitiativeMapping(
    //     ID.fromResponseObject(this.localInitiative.id.intID, 'tactics'),
    //     ID.fromResponseObject(0, 'tactics'),
    //     '',
    //     ID.fromResponseObject(tacticType.id.clone().intID, 'tactic_types'),
    //     tacticType.name
    //   )
    //   this.localInitiative.relatedInitiatives.push(newMappingForType)

    //   return newMappingForType
    // },
    // resetRelatedInitiatives() {
    //   this.localInitiative.relatedInitiatives = []
    //   if (this.$store.getters.currentTacticIntID !== 0) {
    //     this.createPlaceholderRelatedInitiatives()
    //   }
    // },
    setInitialValues() {
      this.initialTacticName = this.localInitiative.title
      // this.initialEstimatedCost = this.localInitiative.estimatedCost
      // this.initialActualCost = this.localInitiative.actualCost
      this.initialStartDate = JSON.stringify(this.localInitiative.startDate)
      this.initialEndDate = JSON.stringify(this.localInitiative.endDate)
      // this.initialChannel = JSON.stringify(this.selectedChannel)
      this.initialType = JSON.stringify({ ...this.selectedType, initiatives: [] })
      // this.initialPlatform = JSON.stringify(this.selectedPlatforms)
      this.initialSummary = JSON.stringify(this.localInitiative.summary)
      // this.initialRelatedInitiatives = JSON.stringify(
      //   this.localInitiative.relatedInitiatives
      // )
    },
    setInitialConditionalValues() {
      //storing the initial values to compare them later
      // this.localInitiative.typeValues.forEach((v) => {
      //   this.initialFieldValues[v.tacticFieldId.intID] = v.value
      // })
      //storing the updated values === initial values to compare them at the first render
      // this.localInitiative.typeValues.forEach((v) => {
      //   this.updatedFieldValues[v.tacticFieldId.intID] = v.value
      // })
      this.initialTags = [...this.localInitiative.tags]
    },
    compareObjects(object1, object2) {
      const keys1 = Object.keys(object1)
      const keys2 = Object.keys(object2)

      if (
        keys1.length !== keys2.length ||
        (keys1.length === 0 && keys2.length === 0)
      ) {
        this.enableSaveButton()
        return false
      }

      for (const key of keys1) {
        if (object1[key] !== object2[key]) {
          this.enableSaveButton()
          return false
        }
      }

      this.disableSaveButton()
      return true
    },
    nonConditionalChange() {
      if (
        !this.localInitiative.title ||
        this.localInitiative.title === '' ||
        !this.selectedType ||
        !this.selectedType.id ||
        this.selectedType.id.intID === 0
      ) {
        this.disableSaveButton()
      } else if (
        this.initialTacticName === this.localInitiative.title &&
        // this.initialEstimatedCost === this.localInitiative.estimatedCost &&
        // this.initialActualCost === this.localInitiative.actualCost &&
        this.initialStartDate === JSON.stringify(this.localInitiative.startDate) &&
        this.initialEndDate === JSON.stringify(this.localInitiative.endDate) &&
        // this.initialChannel === JSON.stringify(this.selectedChannel) &&
        this.initialType === JSON.stringify({ ...this.selectedType, initiatives: [] }) &&
        // this.initialPlatform === JSON.stringify(this.selectedPlatforms) &&
        // this.initialRelatedInitiatives ===
        //   JSON.stringify(this.localInitiative.relatedInitiatives) &&
        // JSON.stringify(this.updatedFieldValues) ===
        //   JSON.stringify(this.initialFieldValues) &&
        this.initialSummary === JSON.stringify(this.localInitiative.summary)
      ) {
        this.disableSaveButton()
      } else {
        this.enableSaveButton()
      }
    },
    // conditionalChange(field, val) {
    //   this.combinedTacticFields.forEach(() => {
    //     this.updatedFieldValues[field.id.intID] = val
    //   })
    //   if (
    //     JSON.stringify(this.updatedFieldValues) ===
    //     JSON.stringify(this.initialFieldValues)
    //   ) {
    //     this.disableSaveButton()
    //   } else {
    //     this.enableSaveButton()
    //   }
    // },
    showCancelConfirmation(event) {
      if (this.saveButtonDisabled) {
        // this.resetRecurrence()
        this.routeToMostRecentOtherView()
      } else {
        this.$confirm.require({
          acceptLabel: 'YES',
          rejectLabel: 'NO',
          target: event.currentTarget,
          message:
            'Are you sure you want to cancel? Your changes will be lost.',
          accept: () => {
            if (this.isCreateInitiative) {
              this.currentInitiative.tags = []
            }
            // this.resetRecurrence()
            this.routeToMostRecentOtherView()
          },
          reject: () => {
            // Cancel rejected
          },
        })
      }
    },
    updateSelectedChannelTypePlatform() {
      // this.currentPlan.initiativeChannel.forEach((channel) => {
      this.currentPlan.initiativeChannel.sortedInitiativeTypes.forEach((type) => {
        if (type.id.intID === this.localInitiative.initiativeType.id.intID) {
          // this.selectedChannel = this.currentPlan.initiativeChannel
          this.selectedType = type
          // if (this.localInitiative.tacticPlatforms?.length) {
          //   this.selectedPlatforms = this.selectedType.tacticPlatforms.filter(
          //     (platform) =>
          //       this.localInitiative.tacticPlatforms?.filter(
          //         (platformOnTactic) =>
          //           platformOnTactic.id.intID === platform.id.intID
          //       ).length
          //   )
          // }
        }
      })
      // })

      // if (this.isInitiative && this.localInitiative.id.intID === 0) {
      //   this.selectedChannel = this.currentPlan.consolidatedInitiativeChannel
      // }
    },
    updateEndDateInputVisibility() {
      this.shouldShowEndDateInput =
        this.localInitiative.endDate.toString() !==
        this.localInitiative.startDate.toString()
      this.shouldShowTimeInput = !this.localInitiative.isAllDay
    },
    // onChannelInputChange() {
    //   this.selectedType = new TacticType()
    //   this.selectedPlatforms = []
    // },
    // onTypeInputChange() {
    //   if (!this.isInitiative) {
    //     this.selectedPlatforms = []
    //     this.updateLocalFieldValues()
    //   }
    // },
    // onPlatformInputChange() {
    //   if (!this.selectedPlatforms) {
    //     this.selectedPlatforms = []
    //   }
    // },
    // onRepeatRuleInputChange(e) {
    //   if (this.localInitiative.rrule === 'custom') {
    //     // Prevent focus error
    //     e.originalEvent.stopPropagation()

    //     // Update selected day of week in recurrence modal
    //     this.customRecurrence.byweekday =
    //       this.customRecurrenceFields.byweekday[
    //         this.localInitiative.startDate.getDay()
    //       ].value

    //     // Show recurrence modal
    //     this.showCustomRecurrenceDialog = true
    //     this.localInitiative.isCustomRecurrence = true
    //   }
    // },
    // handleCustomRecurrenceModalClose() {
    //   if (this.localInitiative.rrule === 'custom') {
    //     this.resetRecurrence()
    //   }
    // },
    // onCustomRecurrenceSubmit() {
    //   this.nonConditionalChange()
    //   const {freq, interval, monthlyRule, byweekday} = this.customRecurrence
    //   let rule = `FREQ=${freq};INTERVAL=${interval}`
    //   if (freq === 'WEEKLY') {
    //     rule += `;BYWEEKDAY=${byweekday}`
    //   }
    //   if (freq === 'MONTHLY') {
    //     rule += `;${monthlyRule}`
    //   }

    //   const rrule = rrulestr(rule, {dtstart: this.localInitiative.startDate})
    //   this.localInitiative.rrule = rrule.toString()
    //   this.customRecurrence.recurrenceText = rrule.toText()
    //   this.localInitiative.isCustomRecurrence = true
    //   this.showCustomRecurrenceDialog = false
    // },
    // updateLocalFieldValues() {
    //   this.combinedTacticFields.forEach((field) => {
    //     let thisValue: TacticFieldValue = new TacticFieldValue(
    //       new ID(),
    //       new ID(field.id.intID, field.id.apiID)
    //     )

    //     this.localInitiative.typeValues.find((value) => {
    //       if (value.tacticFieldId.intID == field.id.intID) {
    //         thisValue = value
    //       }
    //     })

    //     const existingLocalValue = this.nonReactive.localFieldValues?.find(
    //       (localValue) => localValue.tacticFieldId.intID === field.id.intID
    //     )
    //     if (existingLocalValue) {
    //       thisValue.value = existingLocalValue.value
    //     } else {
    //       this.nonReactive.localFieldValues.push(thisValue)
    //     }

    //     const existingUrlMappingForField = this.customImageFieldUrlsMap?.find(
    //       (urlMapping) => urlMapping.fieldId === field.id.intID
    //     )
    //     if (
    //       field.type == TacticFieldType.image &&
    //       !!thisValue.value &&
    //       existingUrlMappingForField?.valueId != thisValue.value
    //     ) {
    //       this.$store.getters.services.tactics
    //         .getMediaAsset(thisValue.value)
    //         .then((response) => {
    //           this.customImageFieldUrlsMap =
    //             this.customImageFieldUrlsMap.concat({
    //               fieldId: field.id.intID,
    //               valueId: thisValue.value,
    //               url: response.fileLocation,
    //             })
    //         })
    //     }
    //   })
    // },
    // getFieldValueForFieldId(fieldId: ID): TacticFieldValue {
    //   // this.updateLocalFieldValues()
    //   return this.nonReactive.localFieldValues.find(
    //     (value) => value.tacticFieldId.intID == fieldId.intID
    //   )
    // },
    // persistFieldValue(fieldValue: TacticFieldValue): Promise<TacticFieldValue> {
    //   return new Promise((resolve, reject) => {
    //     if (fieldValue.id.intID == 0) {
    //       this.$store.getters.services.tactics
    //         .createTacticFieldValue(fieldValue)
    //         .then(
    //           (returnedFieldValue) => {
    //             resolve(returnedFieldValue)
    //           },
    //           (error) => {
    //             reject(error)
    //           }
    //         )
    //     } else {
    //       this.$store.getters.services.tactics
    //         .updateTacticFieldValue(fieldValue)
    //         .then(
    //           (returnedFieldValue) => {
    //             resolve(returnedFieldValue)
    //           },
    //           (error) => {
    //             reject(error)
    //           }
    //         )
    //     }
    //   })
    // },
    updateTacticWithStashedLocalPropertyValues(
      tacticToStash: Tactic,
      tacticToUpdate
    ): Tactic {
      // Stash and re-applylead/nested values because the API only populates them when requesting plan
      const returnTactic = tacticToUpdate
      returnTactic.isLead = tacticToStash.isLead
      returnTactic.isNested = tacticToStash.isNested
      returnTactic.abbreviatedPlanName = tacticToStash.abbreviatedPlanName
      returnTactic.tacticPlatforms = JSON.parse(
        JSON.stringify(tacticToStash.tacticPlatforms)
      ) // Deep cloning tacticPlatforms array because TacticPlatform objects were losing their name values
      return returnTactic
    },
    async handleSaveInitiative(shouldPreventRouting = false) {
      const summaryChanged = this.initialSummary !== JSON.stringify(this.localInitiative.summary)

      //Create/update all field values
      const shouldAbortTacticSave = false
      // const newFieldValues: TacticFieldValue[] = []
      // for (let i = 0; i < this.nonReactive.localFieldValues.length; i += 1) {
      //   await this.persistFieldValue(this.nonReactive.localFieldValues[i]).then(
      //     (returnedFieldValue) => {
      //       newFieldValues.push(returnedFieldValue)
      //     },
      //     (error) => {
      //       //TODO: delete value objects in newFieldValues?
      //       shouldAbortTacticSave = true
      //     }
      //   )
      // }

      // Return a promise after create or update to suppoprt additional actions after save
      return new Promise<Initiative>((resolve, reject) => {
        // this.localInitiative.typeValues = newFieldValues
        if (shouldAbortTacticSave) {
          reject()
        }

        // only include rrule if repeats box is checked
        // if (!this.localInitiative.repeats) {
        //   this.localInitiative.rrule = ''
        // }

        //Create/update tactic
        this.localInitiative.initiativeType = this.selectedType
        // this.localInitiative.tacticPlatforms = this.selectedPlatforms
        this.localInitiative.planId = this.$store.getters.currentPlan.id
        if (this.isCreateInitiative) {
          this.localInitiative.creatorId = this.$store.getters.currentUser.id

          this.$store.getters.services.initiatives
            .create(this.localInitiative)
            .then(async (returnedInitiative: Initiative) => {
              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.success,
                summary: 'Initiative created.',
                life: 3000,
              })

              // Attach associated documents
              this.localInitiative.documents.forEach((document) => {
                returnedInitiative.documentIds.push(document.id)
                document.initiatives.push(returnedInitiative.id)
                this.$store.getters.services.documents.update(document)
              })

              // If adding to a lead plan, set isLead to true on new tactic
              returnedInitiative.isLead = this.$store.getters.currentPlan.isLead

              // Add new initiative to current plan in global store
              this.$store.dispatch('addInitiativeToCurrentPlan', returnedInitiative)

              if (summaryChanged && this.localInitiative.summary) {
                // Await summary creation before routing so the re-fetch after navigation
                // returns the initiative with initiativeSummary.contentUrl already populated
                await this.$store.getters.services.initiatives
                  .createInitiativeSummary(returnedInitiative.id.apiID, this.localInitiative.summary)
                  .then((summaryData) => {
                    returnedInitiative.initiativeSummary = summaryData
                    returnedInitiative.summary = this.localInitiative.summary
                  })
                  .catch(() => {})
              }

              // Route back if performing a normal save (not add new or copy) of a new tactic
              if (shouldPreventRouting !== true) {
                this.routeToMostRecentOtherView()
              }

              this.setInitialConditionalValues()
              this.setInitialValues()
              this.disableSaveButton()
              resolve(returnedInitiative)
            })
        } else {
          this.$store.getters.services.initiatives
            .update(this.localInitiative)
            .then((returnedInitiative) => {
              Vue.prototype.$toast.add({
                severity: AlertMessageSeverity.success,
                summary: 'Initiative updated.',
                life: 3000,
              })

              const currentSummaryContent = this.localInitiative.summary
              if (summaryChanged) {
                const existingSummary = this.localInitiative.initiativeSummary
                const summaryPromise = existingSummary
                  ? this.$store.getters.services.initiatives.updateInitiativeSummary(
                      returnedInitiative.initiativeSummary.id.intID,
                      this.localInitiative.summary
                    )
                  : this.$store.getters.services.initiatives.createInitiativeSummary(
                      returnedInitiative.id.apiID,
                      this.localInitiative.summary
                    )
                summaryPromise.then((summaryData) => {
                  returnedInitiative.initiativeSummary = summaryData
                  this.$store.dispatch('updateInitiativeInCurrentPlan', returnedInitiative).then(() => {
                    this.localInitiative = this.$store.getters.currentInitiative
                    this.localInitiative.summary = currentSummaryContent
                    this.setInitialConditionalValues()
                    this.setInitialValues()
                    this.disableSaveButton()
                    resolve(returnedInitiative)
                  })
                })
              } else {
                // Update initiative in global store (this also updates customizations via populateFrontEndPlanObjects)
                this.$store.dispatch('updateInitiativeInCurrentPlan', returnedInitiative).then(() => {
                  // Update local reference to the updated initiative from the store
                  this.localInitiative = this.$store.getters.currentInitiative
                  this.localInitiative.summary = currentSummaryContent

                  this.setInitialConditionalValues()
                  this.setInitialValues()
                  this.disableSaveButton()
                  resolve(returnedInitiative)
                })
              }
            })
        }
      })
    },
    handleDeleteInitiative(event) {
      this.$confirm.require({
        acceptLabel: 'YES',
        rejectLabel: 'NO',
        target: event.currentTarget,
        message: 'Are you sure you want to delete this initiative?',
        acceptClass: 'btn-delete-accept',
        accept: () => {
          this.$store.getters.services.initiatives
            .delete([this.localInitiative.id.intID])
            .then(
              () => {
                // Delete any associated initiativeCustomizations
                this.localInitiative.initiativeCustomizations.forEach((customization) => {
                  this.$store.getters.services.initiatives.deleteCustomization([customization.id.intID])
                })

                this.$store.commit('updateIsUIBlocked', true)

                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.success,
                  summary: 'Initiative deleted.',
                  life: 3000,
                })
                this.$store
                  .dispatch('removeInitiativeFromCurrentPlanById', this.localInitiative.id)
                  .finally(() => {
                    this.$store.commit('updateIsUIBlocked', false)
                    this.routeToMostRecentOtherView()
                  })
              },
              (error) => {
                Vue.prototype.$toast.add({
                  severity: AlertMessageSeverity.error,
                  summary:
                    'There was an error deleting this initiative. Please try again.',
                })
              }
            )
        },
        reject: () => {
          //Delete rejected
        },
      })
    },
    // resetRecurrence() {
    //   // if you cancel a new tactic that has repeat values, then try
    //   // to create a new one again it will still have these values
    //   // so delete them
    //   if (this.localInitiative.id.intID === 0) {
    //     this.localInitiative.repeats = false
    //     this.localInitiative.isCustomRecurrence = false
    //     this.localInitiative.rrule = null
    //   }
    // },
    routeToMostRecentOtherView() {
      // Navigate to the nearest route in history that isn't the TacticDetail
      let foundOtherRoute = false
      const thisRouteName = this.$route.name
      this.$store.getters.routeHistory.toReversed().forEach((route, i) => {
        if (
          !foundOtherRoute &&
          route.name !== 'SignIn' &&
          ((thisRouteName === 'TacticDetail' &&
            route.name === 'InitiativeDetail') ||
            (thisRouteName === 'TacticDetail' &&
              route.name !== 'TacticDetail') ||
            (thisRouteName === 'InitiativeDetail' &&
              route.name !== 'InitiativeDetail'))
        ) {
          foundOtherRoute = true
          this.$router.go(i * -1)
        }
      })
      // Fallback if no other route is found, just go to last route in history
      if (foundOtherRoute === false) {
        console.log('no other route found')
        this.$router.back()
      }
    },
    onTagListUpdate(updatedList: Tag[]) {
      this.localInitiative.tags = updatedList
      this.tagUpdateItterator += 1
      this.compareObjects(this.localInitiative.tags, this.initialTags)
    },
    handleRemoveTag(id: ID) {
      this.localInitiative.tags = this.localInitiative.tags.filter(
        (tag) => tag.id.intID != id.intID
      )
      this.compareObjects(this.localInitiative.tags, this.initialTags)
    },
    onMultiDayChange() {
      if (this.shouldShowEndDateInput === true) {
        this.localInitiative.isAllDay = true
        this.onAllDayChange()
      } else {
        this.localInitiative.endDate = new Date(
          this.localInitiative.startDate.toString()
        )
      }
    },
    onAllDayChange() {
      // Reset hours/minutes/seconds if changing tactic to/from all-day
      this.localInitiative.startDate.setHours(8, 0, 0, 0)
      this.localInitiative.endDate.setHours(8, 0, 0, 0)

      // Manage time input visibility
      this.shouldShowTimeInput = !this.localInitiative.isAllDay
    },
    normalizeAllDayDates() {
      // PrimeVue's Calendar resets the picked date to local midnight whenever
      // showTime is false (always the case for all-day items), regardless of
      // the date's previous time-of-day. Midnight has zero margin against
      // timezone-driven day rollover once serialized to UTC on save, so
      // re-anchor to local noon immediately after every pick.
      if (!this.localInitiative.isAllDay) {
        return
      }
      this.localInitiative.startDate.setHours(12, 0, 0, 0)
      this.localInitiative.endDate.setHours(12, 0, 0, 0)
    },
    onUnscheduledChange() {
      if (this.localInitiative.isUnscheduled) {
        // Remove start and end dates
        this.localInitiative.startDate = new Date(0)
        this.localInitiative.endDate = new Date(0)
        // Remove repeat
        // this.localInitiative.rrule = null
        // this.localInitiative.recurrenceText = ''
        // this.localInitiative.recurrenceEndDate = new Date(0)
        // this.localInitiative.isCustomRecurrence = false
        // Clear related initiatives selections
        // this.resetRelatedInitiatives()
      } else {
        // Reset dates
        this.localInitiative.startDate = new Date()
        this.localInitiative.startDate.setDate(1)
        this.localInitiative.startDate.setHours(8, 0, 0, 0)
        this.localInitiative.endDate = new Date()
        this.localInitiative.endDate.setDate(1)
        this.localInitiative.endDate.setHours(8, 0, 0, 0)
      }
    },
    // onRelatedInitiativeChange($event, tacticType) {
    //   let thisMapping = this.localInitiative.relatedInitiatives.find(
    //     (mapping: RelatedInitiativeMapping) =>
    //       mapping.tacticTypeId.intID === tacticType.id.intID
    //   )
    //   if (!thisMapping) {
    //     thisMapping = this.createSinglePlaceholderRelatedInitiative(tacticType)
    //   }

    //   if ($event.value) {
    //     const thisInitiative = this.$store.getters.currentInitiatives.find(
    //       (tactic: Tactic) => tactic.id.intID === $event.value.intID
    //     )
    //     thisMapping.initiativeId.intID = thisInitiative
    //       ? thisInitiative.id.intID
    //       : $event.value.intID
    //     thisMapping.initiativeTitle = thisInitiative ? thisInitiative.title : ''
    //   } else {
    //     thisMapping.initiativeId = new ID()
    //     thisMapping.initiativeTitle = ''
    //   }
    // },
    onInputChange() {
      if (!this.isMonthlyOnly) {
        if (this.shouldShowEndDateInput == false) {
          this.localInitiative.endDate = new Date(
            this.localInitiative.startDate.toString()
          )
        }
        if (this.localInitiative.endDate < this.localInitiative.startDate) {
          this.localInitiative.endDate = this.localInitiative.startDate
        }
      }

      // if (!this.localInitiative.relatedInitiatives) {
      //   this.resetRelatedInitiatives()
      //   this.compareObjects(
      //     JSON.stringify(this.localInitiative.relatedInitiatives),
      //     this.initialRelatedInitiatives
      //   )
      // }

      // if (this.localInitiative.recurrenceEndDate) {
      //   this.localInitiative.recurrenceEndDate.setHours(23, 59, 59, 999)
      // }

      //TODO: currently using forceUpdate because some input components were not truggering DOM render, this is likely because their models are properties of currentTactic and not reactive, resolve this issue by ensuring that these models are reactive
      this.$forceUpdate()
    },
    // clearRepeat() {
    //   this.localInitiative.repeats = false
    //   this.localInitiative.recurrenceText = ''
    //   this.localInitiative.rrule = ''
    // },
    // getMonthlyByDay(
    //   startDate: Date,
    //   dtStart: string,
    //   onlyReturnMonthlyRule = false
    // ) {
    //   const d = new Date(startDate.getTime())
    //   const dayOfWeek = d.getDay()
    //   const month = d.getMonth()
    //   const datesWithSameDayOfWeek = [] as Date[]

    //   const recurrenceEndDate = this.localInitiative.recurrenceEndDate ? new Date(this.localInitiative.recurrenceEndDate) : null
    //   const untilDate = recurrenceEndDate ? this.getRecurranceFormattedStringForDate(recurrenceEndDate, false) : null

    //   // Get the first instance of the day of week in the month
    //   d.setDate(1)
    //   while (d.getDay() !== dayOfWeek) {
    //     d.setDate(d.getDate() + 1)
    //   }

    //   // get all instances of day of week
    //   while (d.getMonth() === month) {
    //     datesWithSameDayOfWeek.push(new Date(d))
    //     d.setDate(d.getDate() + 7)
    //   }

    //   // find our start date's index of those
    //   let indexOfStartDate = 0
    //   datesWithSameDayOfWeek.forEach((date, index) => {
    //     if (isSameDay(startDate, date)) {
    //       indexOfStartDate = index
    //     }
    //   })

    //   const isFifthInstanceOfWeekDay = indexOfStartDate > 4

    //   if (onlyReturnMonthlyRule) {
    //     return {
    //       value: isFifthInstanceOfWeekDay
    //         ? `BYSETPOS=-1;BYDAY=${format(startDate, 'EEEEEE').toUpperCase()};${untilDate}`
    //         : `BYSETPOS=${indexOfStartDate + 1};BYDAY=${format(
    //             startDate,
    //             'EEEEEE'
    //           ).toUpperCase()}${untilDate ? ';'+untilDate : ''}`,
    //       label: isFifthInstanceOfWeekDay
    //         ? `Monthly on last ${format(startDate, 'eeee')} of the month`
    //         : `The ${indexOfStartDate + 1}${
    //             ['st', 'nd', 'rd'][
    //               ((((indexOfStartDate + 1 + 90) % 100) - 10) % 10) - 1
    //             ] || 'th'
    //           } ${format(startDate, 'eeee')} of the month`,
    //     }
    //   }
    //   return {
    //     value: isFifthInstanceOfWeekDay
    //       ? `${dtStart}FREQ=MONTHLY;BYSETPOS=-1;BYDAY=${format(
    //           startDate,
    //           'EEEEEE'
    //         ).toUpperCase()}${untilDate ? ';'+untilDate : ''}`
    //       : `${dtStart}FREQ=MONTHLY;BYSETPOS=${
    //           indexOfStartDate + 1
    //         };BYDAY=${format(startDate, 'EEEEEE').toUpperCase()}${untilDate ? ';'+untilDate : ''}`,
    //     label: isFifthInstanceOfWeekDay
    //       ? `Monthly on last ${format(startDate, 'eeee')} of the month`
    //       : `Monthly on the ${indexOfStartDate + 1}${
    //           ['st', 'nd', 'rd'][
    //             ((((indexOfStartDate + 1 + 90) % 100) - 10) % 10) - 1
    //           ] || 'th'
    //         } ${format(startDate, 'eeee')} of the month`,
    //   }
    // },
    // handleEditCustomRuleClick(e) {
    //   e.preventDefault()
    //   this.showCustomRecurrenceDialog = true
    // },
    // handleRemoveCustomRuleClick(e) {
    //   e.preventDefault()
    //   this.localInitiative.isCustomRecurrence = false
    //   this.localInitiative.rrule = ''
    //   this.localInitiative.recurrenceText = ''
    // },
    onMonthlyFocusDateSelect() {
      // Ensure start/end dates for tactic span first and last day of the selected month
      this.localInitiative.startDate.setDate(1)
      this.localInitiative.endDate = new Date(this.localInitiative.startDate)
      this.localInitiative.endDate.setMonth(
        this.localInitiative.startDate.getMonth() + 1
      )
      this.localInitiative.endDate.setDate(0)
    },
    // updateCustomRecurrenceValues() {
    //   const {rrule, isCustomRecurrence} = this.localInitiative
    //   if (rrule && isCustomRecurrence) {
    //     const {startDate} = this.localInitiative
    //     const rule = rrulestr(rrule)
    //     const dtStart = this.getRecurranceFormattedStringForDate(startDate)

    //     let freq = (RRule as any).optionsToString({
    //       freq: rule.options.freq,
    //     })
    //     freq = freq.substr(freq.indexOf('FREQ=') + 5)

    //     let monthlyRule = ''
    //     let byweekday = RecurrenceByweekday['MO']
    //     if (freq === RecurrenceFrequency['MONTHLY']) {
    //       const monthlyOptions = [
    //         {
    //           value: `BYMONTHDAY=${format(startDate, 'd')}`,
    //           label: `The ${format(startDate, 'do')}`,
    //         },
    //         {
    //           ...this.getMonthlyByDay(startDate, dtStart, true),
    //         },
    //       ]
    //       monthlyRule =
    //         rrule.indexOf('BYMONTHDAY') >= 0
    //           ? monthlyOptions[0].value
    //           : monthlyOptions[1].value
    //     } else if (freq === RecurrenceFrequency['WEEKLY']) {
    //       const weekRule = (RRule as any).optionsToString({
    //         byweekday: rule.options.byweekday,
    //       })
    //       byweekday =
    //         RecurrenceByweekday[weekRule.substr(weekRule.indexOf('BYDAY=') + 6)]
    //     }

    //     this.customRecurrence = {
    //       recurrenceText: rule.toText(),
    //       freq: RecurrenceFrequency[freq],
    //       interval: rule.options.interval,
    //       monthlyRule,
    //       byweekday,
    //     }
    //     this.localInitiative.isCustomRecurrence = true
    //   }
    // },
    // openInNewWindow(url) {
    //   if (url.substr(0, 10).indexOf('://') == -1) {
    //     url = `https://${url}`
    //   }
    //   window.open(url, '_blank')
    // },
    // isFieldType(field, type) {
    //   return field.type === TacticFieldType[type]
    // },
    // uploadCustomFieldImage(fieldId: ID, fileData) {
    //   const file = new FormData()
    //   file.append('file', fileData.files[0])

    //   this.$store.getters.services.tactics
    //     .importCustomFieldImage(this.currentTactic.id.intID, fieldId, file)
    //     .then((response) => {
    //       const thisImageField = this.getFieldValueForFieldId(fieldId)
    //       thisImageField.value = response.id.intID.toString()
    //       this.customImageFieldUrlsMap = this.customImageFieldUrlsMap.concat({
    //         fieldId: fieldId.intID,
    //         valueId: response.id.intID,
    //         url: response.fileLocation,
    //       })
    //       this.$forceUpdate()
    //       this.conditionalChange(thisImageField, thisImageField.value)
    //     })
    // },
    // removeCustomFieldImage(fieldId: ID) {
    //   const thisImageField = this.getFieldValueForFieldId(fieldId)
    //   thisImageField.value = ''
    //   this.customImageFieldUrlsMap = this.customImageFieldUrlsMap.filter(
    //     (imageField) => imageField.fieldId != fieldId.intID
    //   )
    //   this.conditionalChange(thisImageField, thisImageField.value)
    // },
    // getCustomImageFieldUrl(fieldId) {
    //   // TODO: utf
    //   const val = this.customImageFieldUrlsMap.find(
    //     (imageUrlMapping) => imageUrlMapping.fieldId == fieldId.intID
    //   )
    //   return val ? val.url : ''
    // },
    copyInitiative() {
      this.$store.getters.services.initiatives
        .get([this.$route.query.copyof])
        .then((response: Initiative) => {
          response.title = `Copy of ${response.title}`

          const summaryContentUrl = response.initiativeSummary?.contentUrl
          response.initiativeSummary = null // Clear so save creates a new summary rather than updating the original
          this.localInitiative = response

          this.updateSelectedChannelTypePlatform()
          this.updateEndDateInputVisibility()
          // this.updateLocalFieldValues()

          //Apply tags from tag IDs
          this.localInitiative.tags = this.$store.getters.currentPlan.tags.filter(
            (tag) =>
              this.localInitiative.tagIds
                .map((id) => id.intID)
                .includes(tag.id.intID)
          )

          if (summaryContentUrl) {
            this.$store.getters.services.initiatives
              .fetchSummaryContent(summaryContentUrl)
              .then((html: string) => {
                this.localInitiative.summary = html
              })
          }
        })
    },
    updateCurrentInitiativeStartDate(newStartDate) {
      this.localInitiative.startDate = newStartDate
      this.nonConditionalChange()
      this.$forceUpdate()
    },
    updateCurrentInitiativeEndDate(newEndDate) {
      this.localInitiative.endDate = newEndDate
      this.nonConditionalChange()
    },
    // isFieldUrlType(field) {
    //   return field.type === TacticFieldType.url
    // },
    // updateEditModeFieldIds(id: number) {
    //   if (this.editModeFieldIds.includes(id)) {
    //     this.editModeFieldIds = this.editModeFieldIds.filter(
    //       (fieldId) => fieldId != id
    //     )
    //   } else {
    //     this.editModeFieldIds = this.editModeFieldIds.concat([id])
    //   }
    // },
    // getInitiativeForId(id: ID) {
    //   const thisInitiative = this.$store.getters.currentInitiatives.find(
    //     (tactic) => tactic.id.intID == id.intID
    //   )
    //   return thisInitiative ? thisInitiative : new Tactic()
    // },
    onEditorTextChange(event, refString) {
      if (
        event.htmlValue.length > 999900 &&
        event.htmlValue.length <= 1000000
      ) {
        // @ts-expect-error
        document.getElementById(refString).innerHTML =
          '<p class="warning-message">Content in this field is approaching the 1MB limit.</p>'
      } else if (event.htmlValue.length > 1000000) {
        // @ts-expect-error
        document.getElementById(refString).innerHTML =
          '<p class="error-message">Content in this field has exceeded the 1MB limit, some content will be lost.</p>'
      } else {
        // @ts-expect-error
        document.getElementById(refString).innerHTML = ''
      }
    },
    deleteDocument(event, documentId, initiative: Initiative) {
      this.$confirm.require({
        acceptLabel: 'Delete',
        rejectLabel: 'Cancel',
        message: `Are you sure you want to delete this document?`,
        target: event.currentTarget,
        acceptClass: 'btn-delete-accept',
        accept: () => {
          this.$store.getters.services.documents.delete(documentId).then(() => {
            initiative.documents = initiative.documents.filter(
              (doc) => doc.id.intID !== documentId
            )
            this.$store.getters.currentInitiative.documents =
              this.$store.getters.currentInitiative.documents.filter(
                (doc) => doc.id.intID !== documentId
              )
          })
          // TODO: also delete MediaAsset?
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      })
    },
    onFileUpload(e, initiative: Initiative) {
      initiative.newFile = e.target.files[0]
      initiative.newFileName = e.target.files[0].name
    },
    uploadFile(initiative) {
      const newFile = new FormData()

      if (!initiative.newFile) {
        Vue.prototype.$toast.add({
          severity: AlertMessageSeverity.warn,
          summary: 'You must upload file first',
        })
        return
      }

      const file = new File([initiative.newFile], initiative.newFileName, {
        type: initiative.newFile.type,
        lastModified: initiative.newFile.lastModified,
      })
      newFile.append('file', file)

      this.$store.getters.services.users
        .mediaAsset(newFile)
        .then((newAsset) => {
          const newPlanDocument = PlanDocument.fromResponseObject({
            asset: newAsset,
            plan: this.currentPlan.id.intID,
          })
          if (initiative.id.intID !== 0) {
            newPlanDocument.initiatives = [initiative.id]
          }
          this.$store.getters.services.documents
            .create(newPlanDocument)
            .then((newDBPlanDocument) => {
              newPlanDocument.id = ID.fromResponseObject(
                newDBPlanDocument.id,
                'plan_documents'
              )
              // Add document to local tactic and to plan
              initiative.documents.push(newPlanDocument)
              initiative.documentIds.push(newPlanDocument.id)
              this.currentPlan.documents.push(newPlanDocument)

              this.localInitiative.newFile = initiative.newFile = ''
              this.localInitiative.newFileName = initiative.newFileName = ''

              if (initiative.id.intID !== 0) {
                this.$store.getters.services.initiatives
                  .update(initiative)
                  .then(() => {
                    // TODO: Consider revising: This ensures that new documents are displayed when this tactic is reloaded during the same session, but that should be possible by simply updating or replacing the tactic in AppStore
                    this.$store.dispatch('refreshCurrentPlan')
                  })
              }
            })
        })
        .catch(() => {
          Vue.prototype.$toast.add({
            severity: AlertMessageSeverity.warn,
            summary:
              'There was an error uploading the file, try with a smaller file',
          })
        })
    },
  },
})
</script>

<style lang="scss">
@import '@/styles/_imports.scss';

.edit-link {
  @include font-light;
  font-size: 1.1rem;
  background: #ffffff;
  padding: 0.8rem 1.2rem;
  border: 0.1rem solid #707070;
}

.underline {
  text-decoration: underline;
}

.initiative-detail-wrapper {
  .tag-list-column {
    flex-grow: 1;
  }

  .tag-chip {
    padding: 0.7rem 0.7rem 0.7rem 1.6rem;
    border-radius: 1.6rem;
    background-color: $white-smoke;
    color: $night-rider;
    font-size: 1.1rem;
    line-height: 1.6rem;

    .p-button {
      padding: 0;

      .pi {
        font-size: 1.2rem;
      }
    }
  }

  input:disabled,
  .p-component.p-disabled,
  .p-checkbox-box.p-disabled {
    opacity: 1;
    border-color: $nobel;
    border-style: dashed;
  }

  .custom-field-image {
    width: 200px;
  }
}

.initiative-detail-documents-container {
  .p-datatable-thead {
    display: none;
  }

  .p-datatable-tbody {
    border-top: 0.1rem solid rgba(0, 0, 0, 0.08);

    .p-button-text {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  .upload-document-container {
    padding: 2rem 0;
    column-gap: 1rem;
  }
}

.custom-recurrence-dialog-body {
  min-height: 20rem;
  display: flex;
  flex-direction: column;
}

.custom-recurrence-number-input {
  .p-inputnumber-input {
    width: 4rem;
    margin: 0 0.5rem;
    text-align: center;
  }
}

.custom-properties-container {
  .custom-field-url-link {
    color: #333333;
    text-decoration: underline;
  }
}

.custom-field-image-controls {
  position: relative;

  .custom-field-image-controls-container {
    position: absolute;
    top: 5px;
    right: 5px;

    button {
      height: 25px;
      width: 25px;
      background: white;
      margin-left: 5px;

      &:hover {
        background: white !important;
      }
    }
  }
}

.custom-image-dialog {
  img {
    max-width: 100%;
  }

  button {
    position: absolute;
    top: 20px;
    right: 25px;
  }
}

.tag-list-column {
  div.is-lead {
    display: flex;
    column-gap: 1rem;

    &::before {
      content: '\e925'; // pi-home
      display: block;
      font-family: 'primeicons';
      font-size: 1.6rem;
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
    }
  }
}

.related-initiatives-container {
  display: none;

  &:has(.initiative-item-container) {
    display: block;
  }
}

.initiative-item {
  &.is-lead {
    display: flex;
    column-gap: 1rem;

    &::before {
      content: '\e925'; // pi-home
      display: block;
      font-family: 'primeicons';
      font-size: 1.6rem;
      speak: none;
      font-style: normal;
      font-weight: normal;
      font-variant: normal;
      text-transform: none;
    }
  }
}

.p-editor-container.disable-editor {
  // Workaround for Editor component not being disabled (via readonly attribute) when canUserEditFields is false
  pointer-events: none;
}

#btn_tactic_save {
  .p-menu-overlay {
    left: auto !important;
    right: 0 !important;
  }
}

.p-datatable-wrapper span.is-lead {
  display: flex;
  column-gap: 1rem;

  &::before {
    content: '\e925'; // pi-home
    display: block;
    font-family: 'primeicons';
    font-size: 1.6rem;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
  }
}
</style>
